import { render, staticRenderFns } from "./addLiaisons.vue?vue&type=template&id=5c067338&scoped=true&"
import script from "./addLiaisons.vue?vue&type=script&lang=js&"
export * from "./addLiaisons.vue?vue&type=script&lang=js&"
import style0 from "./addLiaisons.vue?vue&type=style&index=0&id=5c067338&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c067338",
  null
  
)

export default component.exports